module.exports = function () {
    $(document).ready(function () {

        var helper = require('../../helper');

        var index = $('#js-property-proposal-works-form').data('index');

        $('body').on('click', ".add_proposed_work", (function() {

            var ruleInputs =
                '<div class="form-group"><div class="col-sm-10">'+
                '<input class="form-control" name="proposed_works['+ index +']" type="text" id="proposed_works">'+
                '</div><div class="col-sm-2">'+
                '<button class="btn btn-add add_proposed_work" type="button" style="border:none;background:transparent;color:green;font-weight: bold;">Add</button>'+
                '</div></div>';

            $("#js-property-proposal-works-form").append(ruleInputs);
            ++index;

            return false;
        }));
    });

    
}();
